import { createContext } from 'react';
export const CommonDataContext = createContext({
    featureFlags: {},
    users: [],
});
